/* tslint:disable */
/* eslint-disable */
/**
 * Tanagra Service API
 * github.com/DataBiosphere/tanagra
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CriteriaGroupSection } from './CriteriaGroupSection';
import {
    CriteriaGroupSectionFromJSON,
    CriteriaGroupSectionFromJSONTyped,
    CriteriaGroupSectionToJSON,
} from './CriteriaGroupSection';

/**
 * 
 * @export
 * @interface Cohort
 */
export interface Cohort {
    /**
     * ID of the cohort, immutable
     * @type {string}
     * @memberof Cohort
     */
    id: string;
    /**
     * ID of a frozen cohort revision, immutable
     * @type {string}
     * @memberof Cohort
     */
    revisionId?: string;
    /**
     * Name of the underlay, immutable
     * @type {string}
     * @memberof Cohort
     */
    underlayName: string;
    /**
     * Name of the study
     * @type {string}
     * @memberof Cohort
     */
    studyId: string;
    /**
     * Human readable name of the cohort
     * @type {string}
     * @memberof Cohort
     */
    displayName: string;
    /**
     * Description of the cohort
     * @type {string}
     * @memberof Cohort
     */
    description?: string;
    /**
     * Criteria group sections that define the entity filter
     * @type {Array<CriteriaGroupSection>}
     * @memberof Cohort
     */
    criteriaGroupSections?: Array<CriteriaGroupSection>;
    /**
     * Timestamp of when the cohort was created
     * @type {Date}
     * @memberof Cohort
     */
    created: Date;
    /**
     * Email of user who created cohort
     * @type {string}
     * @memberof Cohort
     */
    createdBy: string;
    /**
     * Timestamp of when the cohort was last modified
     * @type {Date}
     * @memberof Cohort
     */
    lastModified: Date;
    /**
     * 
     * @type {boolean}
     * @memberof Cohort
     */
    isDeleted?: boolean;
}

/**
 * Check if a given object implements the Cohort interface.
 */
export function instanceOfCohort(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "underlayName" in value;
    isInstance = isInstance && "studyId" in value;
    isInstance = isInstance && "displayName" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "createdBy" in value;
    isInstance = isInstance && "lastModified" in value;

    return isInstance;
}

export function CohortFromJSON(json: any): Cohort {
    return CohortFromJSONTyped(json, false);
}

export function CohortFromJSONTyped(json: any, ignoreDiscriminator: boolean): Cohort {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'revisionId': !exists(json, 'revisionId') ? undefined : json['revisionId'],
        'underlayName': json['underlayName'],
        'studyId': json['studyId'],
        'displayName': json['displayName'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'criteriaGroupSections': !exists(json, 'criteriaGroupSections') ? undefined : ((json['criteriaGroupSections'] as Array<any>).map(CriteriaGroupSectionFromJSON)),
        'created': (new Date(json['created'])),
        'createdBy': json['createdBy'],
        'lastModified': (new Date(json['lastModified'])),
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
    };
}

export function CohortToJSON(value?: Cohort | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'revisionId': value.revisionId,
        'underlayName': value.underlayName,
        'studyId': value.studyId,
        'displayName': value.displayName,
        'description': value.description,
        'criteriaGroupSections': value.criteriaGroupSections === undefined ? undefined : ((value.criteriaGroupSections as Array<any>).map(CriteriaGroupSectionToJSON)),
        'created': (value.created.toISOString()),
        'createdBy': value.createdBy,
        'lastModified': (value.lastModified.toISOString()),
        'isDeleted': value.isDeleted,
    };
}

